import Chapter from "@fae/source/models/Chapter.js"

export default class Game {
    static update(game, delta) {
        // ..
    }
    static load(game) {
        if(window.savestate?.game != undefined) {
            console.log("!!")
            game = {...game, ...window.savestate.game}
            // THIS OVERWRITES BTH RANDOMSEED AND PLAYER
        }
        if(game.chapter != undefined) {
            game.chapter = Chapter.load({
                "chapter": game.chapter,
                "player": game.player,
                "gamekey": game.key,
                "randomSeed": game.randomSeed,
                "deltastageSum": game.deltastageSum,
            })
        }
        return game
    }
}
